import type { PublicStatusResponse } from '@nadoutong/contracts';
import { platformApiRequest } from './client.ts';

export async function getNadoutongPublicStatus(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<PublicStatusResponse> {
  return platformApiRequest<PublicStatusResponse>(
    '/v1/status?brand=nadoutong',
    { signal },
    fetchImpl,
  );
}

export async function getPlatformHealth(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<{ readonly ok: true }> {
  return platformApiRequest<{ readonly ok: true }>('/v1/health', { signal }, fetchImpl);
}
